import {RemoveNonNumeric} from '@shared/MathHelp.ts';

export const MailValidation = (email: string): boolean => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
};

export const isCpf = (cpf: string): boolean => {
    cpf = RemoveNonNumeric(cpf)?.toString() ?? '';
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false; // Check length and repeated digits

    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf[i]) * (10 - i);
    }
    let remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;
    if (remainder !== parseInt(cpf[9])) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf[i]) * (11 - i);
    }
    remainder = (sum * 10) % 11;
    if (remainder === 10) remainder = 0;

    return remainder === parseInt(cpf[10]);
};

export const isCnpj = (cnpj: string): boolean => {
    cnpj = RemoveNonNumeric(cnpj)?.toString() ?? '';
    if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

    let sum = 0;
    for (let i = 0; i < 12; i++) {
        sum += parseInt(cnpj[i]) * ((i < 4) ? (5 - i) : (13 - i));
    }

    let remainder = sum % 11;
    if (remainder < 2) remainder = 0; else remainder = 11 - remainder;
    if (remainder !== parseInt(cnpj[12])) return false;

    sum = 0;
    for (let i = 0; i < 13; i++) {
        sum += parseInt(cnpj[i]) * ((i < 5) ? (6 - i) : (14 - i));
    }
    remainder = sum % 11;
    if (remainder < 2) remainder = 0; else remainder = 11 - remainder;
    return remainder === parseInt(cnpj[13]);
};

export function ToCpfCnpj(value?: string): string
export function ToCpfCnpj(value?: string, options?: {
    allowUndefined?: boolean
}): string | undefined {
    if (!value) return options?.allowUndefined ? undefined : '';

    value = RemoveNonNumeric(value)?.toString() ?? '';
    if (value.length <= 11) {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'); // Cpf format
    } else if (value.length === 14) {
        return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'); // Cnpj format
    }
    return undefined; // Invalid length
};